export default __webpack_public_path__ + "static/Magne-0151d49272946ebcbe6ff1785d96f6c8.jpg";